import { render, staticRenderFns } from "./SelfServeActivation.vue?vue&type=template&id=740593d9&scoped=true"
import script from "./SelfServeActivation.vue?vue&type=script&lang=js"
export * from "./SelfServeActivation.vue?vue&type=script&lang=js"
import style0 from "./SelfServeActivation.vue?vue&type=style&index=0&id=740593d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740593d9",
  null
  
)

export default component.exports